// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"79fc6e34","302":"a09e0bfc","453":"26131370","505":"09e2ca28","664":"edeb2771","926":"39c2e693"}[chunkId] + ".chunk.js";
};